import React from 'react';
import { useTranslation } from 'react-i18next';
import CommonDescriptionField from '../../../common/fields/DescriptionField';
import { OriginalDeviationFieldName } from '../../types';

interface Props {}

const DescriptionField: React.FC<Props> = () => {
  const { t } = useTranslation();

  return (
    <CommonDescriptionField
      fieldName={OriginalDeviationFieldName.DESCRIPTION}
      label={t('originalDeviationPopup.form.description.label')}
      placeholder={t('originalDeviationPopup.form.description.placeholder')}
    />
  );
};
DescriptionField.displayName = 'DescriptionField';

export default DescriptionField;
